import { Controller } from "@hotwired/stimulus"

// Warns, without blocking, when a mobile money number typed for an operator
// starts with a prefix of the OTHER operator (owner's decision of 03/10).
// Numbers are ported from one operator to the other: the form is still sent.
// The prefixes and the wording come from the server
// (MobilePayments::OperatorPrefixWarning.form_data), the same rule as
// MobilePayments::Msisdn. The expected operator is either fixed
// (`operator` value) or read from a select of operators or account kinds.
export default class extends Controller {
  static targets = ["input", "operator", "warning", "message"]
  static values = { operator: String, prefixes: Object, operators: Object, labels: Object, template: String }

  connect() {
    this.check()
  }

  check() {
    const detected = this.detected()
    if (!this.hasWarningTarget) return

    if (detected) {
      const expected = this.expected()
      this.messageTarget.textContent = this.templateValue
        .replace("{detected}", this.labelsValue[detected] || detected)
        .replace("{expected}", this.labelsValue[expected] || expected)
    }
    this.warningTarget.hidden = !detected
  }

  expected() {
    const raw = this.hasOperatorTarget ? this.operatorTarget.value : this.operatorValue
    return this.operatorsValue[raw] || null
  }

  // The operator the prefix belongs to, when it is not the expected one.
  detected() {
    const expected = this.expected()
    const national = this.hasInputTarget ? this.national(this.inputTarget.value) : null
    if (!expected || !national) return null

    const probable = Object.keys(this.prefixesValue).find((operator) =>
      this.prefixesValue[operator].some((prefix) => national.startsWith(prefix)))
    return probable && probable !== expected ? probable : null
  }

  // The 9-digit national number, as MobilePayments::Msisdn.national reads it.
  national(raw) {
    let digits = (raw || "").replace(/\D/g, "")
    while (digits.startsWith("237") && digits.length > 9) digits = digits.slice(3)
    return digits.length === 9 && digits.startsWith("6") ? digits : null
  }
}
